import { Controller } from "react-hook-form";
import Icon from "../Icon/Icon";
import { toggleContainer } from "./toggleContainer";

interface PropsItem {
    label: string
    value: string
    icon?: string | JSX.Element
}
interface ToggleProps {
    items: PropsItem[]
    name: string,
    size?: "md" | "sm" | undefined
}
export const Toggle = (props: ToggleProps) => {
    const { size, items, name } = props
    const { base } = toggleContainer({ size })
    return (
        <div className="flex max-h-[40px] flex-row max-w-2xl rounded-lg text-white-500 overflow-hidden bg-primary-600 w-fit">
            {items.map(item =>
                <Controller
                    name={name}
                    render={({ field }) => (
                        <label className="cursor-pointer flex flex-row gap-2 items-center text-xs">
                            <input
                                type="radio"
                                className="hidden peer"
                                value={item.value}
                                defaultChecked={field.value === item.value}
                                checked={field.value === item.value}
                                onChange={() => field.onChange(item.value)}
                            />
                            <span className={base()}>
                                {item.icon && typeof item.icon === 'string' ? <Icon name={item.icon} /> : item.icon}
                                {item.label}
                            </span>
                        </label>
                    )}
                />
            )}
        </div>
    );
};
